// noinspection SpellCheckingInspection
import Splide from '@splidejs/splide';

window.addEventListener("DOMContentLoaded", () => {
    if (!document.querySelector('.ns-quotes-carousel')) {
        return;
    }

    // noinspection SpellCheckingInspection
    new Splide('.splide', {type: 'loop', autoplay: true}).mount();
});
